<div *ngIf="isIE && content">
    <sbw-ie-overlay [content]="content"></sbw-ie-overlay>
</div>
<div *ngIf="!isIE">
    <div class="header wrapper" [ngClass]="{ fixed: !contentLoaded }">
        <header class="row">
            <div class="column small-12">
                <a href="..">
                    <img class="sbw-logo" src="/_ng/booking/assets/logo.svg" title="SeaBookWeb" />
                </a>
            </div>
        </header>
    </div>
    <sbw-loader *ngIf="!contentLoaded" [label]="loadResource"></sbw-loader>
    <router-outlet></router-outlet>
    <sbw-chat></sbw-chat>
    <div *ngIf="content">
        <sbw-okta *ngIf="oktaService.oktaInUse()" [content]="content"></sbw-okta>
    </div>
</div>
